import {FC} from 'react'
import {settings} from "../../../constants/global";


interface Props {
    booking: Booking
}

const Logo: FC<Props> = ({booking}) => {
    if(booking.booking_flow !== 'hjulskifte-arval') {
        return
    }

    return (
        <div className="arval">
            <div className="arval__badge container">
                <img className={"arval__logo"} src={`${settings.url}/storage/images/arval.png`}/>
                <div>Arval - Hjulskifte</div>
            </div>
        </div>
    )
}

export default Logo
